const SET_IS_AUTHENTICATED = "setIsAuthenticated";
const GET_HEADER_INFO = "getHeaderInfo";
const SET_HEADER_INFO = "setHeaderInfo";
const SET_DISPLAY_OFF_CANVAS_BTN = "setDisplayOffCanvasBtn";
const SET_ACTIVE_TAB_ID = 'setActiveTabId';
const MENU_HOME = 'home';

export {
  SET_IS_AUTHENTICATED,
  GET_HEADER_INFO,
  SET_HEADER_INFO,
  SET_DISPLAY_OFF_CANVAS_BTN,
  SET_ACTIVE_TAB_ID,
  MENU_HOME,
};
